import clsx from 'clsx';

import { initialsOf } from '@/features/account/model';
import { useProfileImage } from '@/features/account/hooks';

import styles from './Avatar.module.css';

export interface AvatarProps {
  /** The name the initials fall back to. */
  name: string;
  /** File id in the profile-images bucket, when the user has one. */
  imageId?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * The user's profile image, falling back to their initials.
 *
 * The fallback is not an error state — most accounts have no image, and an
 * image that fails to load should never leave a broken-image icon in the
 * top bar.
 */
export function Avatar({ name, imageId, size = 'sm', className }: AvatarProps) {
  const { url, loading } = useProfileImage(imageId);

  return (
    <span className={clsx(styles.avatar, styles[size], className)} aria-hidden="true">
      {url !== null ? (
        <img className={styles.image} src={url} alt="" />
      ) : loading ? (
        <span className={styles.loading} />
      ) : (
        initialsOf(name)
      )}
    </span>
  );
}
